import { render, staticRenderFns } from "./StepInit.vue?vue&type=template&id=288df197&scoped=true"
import script from "./StepInit.vue?vue&type=script&lang=js"
export * from "./StepInit.vue?vue&type=script&lang=js"
import style0 from "./StepInit.vue?vue&type=style&index=0&id=288df197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288df197",
  null
  
)

export default component.exports